export function createClientError(type, dataSchema) {
    return { type, dataSchema };
}
